import confetti from 'canvas-confetti';
import config from './config';

export default class Confetti {
  confettiController;

  constructor(targetEl, options = {}) {
    this.targetEl = targetEl;
    this.options = {
      ...config,
      ...options,
    };

    this.confettiController = confetti.create(
      targetEl,
      this.options.coreOptions,
    );
  }

  pop(particles = []) {
    if (!particles) {
      return;
    }

    const { renderOptions } = this.options;

    particles.forEach((particle) => {
      const { particleCountModifier } = particle;
      const particleCount = Math.floor(renderOptions.particleCount * particleCountModifier);

      // sucks, but easy
      delete particle.particleCountModifier;

      this.confettiController({
        ...renderOptions.origin,
        ...particle,
        particleCount,
      });
    });
  }
}
